require("!!/Users/aknobloch/Workspaces/dashing/node_modules/script-loader/addScript.js")(require("!!/Users/aknobloch/Workspaces/dashing/node_modules/raw-loader/index.js!/Users/aknobloch/Workspaces/dashing/bower_components/backbone/backbone.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/backbone/backbone.js
// module id = 7
// module chunks = 0